<template>
  <el-dialog :visible.sync="dialogVisible" class="cancel-confirm">
    <div class="content">
      <p>Our slots are limited and you may only reschedule once throughout your application and training process with HAWO. Please show up on time, and try to select times that will not conflict with other obligations.</p>
      <p>Your cancellations/reschedules will be taken into consideration when assessing your overall application results. Emergency cancellations will be reviewed on a case-by-case basis.</p>
      <p>A "no show" at any point in the process disqualifies you from completing the application process.</p>

      <dl class="reason" v-if="isRemark">
        <dt>Kindly specify your reason for {{typeText}}</dt>
        <dd>
          <el-input type="textarea" :rows="3" v-model.trim="remark"></el-input>
        </dd>
      </dl>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false; remark = ''; reject()" size="medium">Cancel</el-button>
      <el-button type="primary" @click="dialogVisible = false; resolve({ type, remark }); remark = '';" size="medium" :disabled="isRemark && remark === ''">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      isRemark: true,
      remark: '',
      type: 'reschedule',
      resolve: () => {},
      reject: () => {
        throw new Error('error')
      }
    }
  },

  computed: {
    typeText() {
      let type = this.type
      let typeText = ''

      switch (type) {
        case 'reschedule':
          typeText = 'rescheduling'
          break

        case 'cancel':
          typeText = 'cancelling'
          break
      }

      return typeText
    }
  },

  methods: {
    open({ type, isRemark }) {
      this.type = type
      this.dialogVisible = true

      if (isRemark !== undefined) {
        this.isRemark = isRemark
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    }
  }
}
</script>

<style lang="less">
.cancel-confirm {
  .el-dialog {
    width: 600px;
  }

  .el-button--primary {
    &:hover {
      color: #fff;
    }
  }

  .el-textarea__inner {
    font-family: 'Microsoft Yahei';

    &:focus {
      border-color: #fcc800;
    }
  }

  .el-dialog__headerbtn:focus .el-dialog__close,
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fcc800;
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #bfcbd9;
  }

  .content {
    line-height: 1.4;

    p {
      margin-bottom: 20px;
    }
  }

  .reason {
    margin-top: 30px;

    dt {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CancelConfirm.vue?53890782